const useWindowDimensions = () => {
  return { width: window.innerWidth, height: window.innerHeight };
};

export default useWindowDimensions;
